import iacp from 'styles/img/sponsors/iacp-logo.png'
import aci from 'styles/img/sponsors/aci-logo.png'
export const IACP_LOGO = iacp;
export const ACI_LOGO = aci;


// WEBPACK FOOTER //
// ./src/constants/sponsor_logos.js